import {ConstructEvidenceComponent} from './ConstructEvidenceComponent';

export default ConstructEvidenceComponent;
